//========================================================================
//========================Bail stuff======================================
//========================================================================

//This adds the price of the bail next to the price of the pendant when the bail is selected.
$(".bail-selections input[type='radio']").click(function(){

	var bailPrice = $(this).attr("data-price");
  	
  if(bailPrice != "" && bailPrice  != "$0.00"){
  	$('span.bail-add-on-price').text(' + ' + bailPrice);
  } else {$('span.bail-add-on-price').text('');}

});


//This allows the different bail options to be chosen and toggles their selection between eachother.

$("div.bail-selections label").click(function(){
	$("div.bail-selections label").not(this).removeClass('tep-active');
  	$("div.bail-selections input").not(this).removeAttr('checked');
  	$(this).siblings('input').attr('checked','checked');
    
  if(!$(this).hasClass('tep-active')){
  	$(this).addClass('tep-active');
  }
  
});


//Changes to make the color button on shirts actually show the color

//$('div.bg_color[data-value="gray"]').css('background','gray');
//$('div.bg_color[data-value="pewter"]').css('background','gray');
//$('div.bg_color[data-value="navy-blue"]').css('background','#4e4b88 ');
//$('div.bg_color[data-value="green"]').css('background','#768461');
//$('div.bg_color[data-value="brown"]').css('background','#73492f');
//$('div.bg_color[data-value="black"]').css('background','black');
//$('div.bg_color[data-value="blue"]').css('background','#4C92FF');
//$('div.bg_color[data-value="purple"]').css('background','#BC48E8');